module.exports = __webpack_public_path__ + "img/img_prduct_content2.b908e5ca.svg";